// Full-document render of the unified sales-channel order-lookup page (step 1):
// PageSkeleton wrapping UnifiedOrderLookupBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { UnifiedOrderLookupBody } from "../components/UnifiedOrderLookupBody";

export const Template = (
    props: templates.UnifiedOrderLookupDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <UnifiedOrderLookupBody {...props} />
        </PageSkeleton>
    );
};
